import { AbpHttpInterceptor, RefreshTokenService, AbpHttpConfigurationService } from 'abp-ng2-module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import * as ApiServiceProxies from './service-proxies';
import { ZeroRefreshTokenService } from '@account/auth/zero-refresh-token.service';
import { ZeroTemplateHttpConfigurationService } from './zero-template-http-configuration.service';
import { ZeroTemplateHttpInterceptor } from './zero-template-http-interceptor';

@NgModule({
    providers: [
        ApiServiceProxies.ClientForIntakeEditServiceProxy, 
        ApiServiceProxies.PsycEvalsesServiceProxy,        
        ApiServiceProxies.DlaSupplementalsServiceProxy,        
        ApiServiceProxies.DLAsServiceProxy,        
        ApiServiceProxies.PracLicenceRateMastersServiceProxy,
        ApiServiceProxies.DischargeSummariesServiceProxy,
        ApiServiceProxies.PersonalSafetyPlansServiceProxy,
        ApiServiceProxies.AcknowledgementsServiceProxy,
        ApiServiceProxies.ShortGoalsServiceProxy,
        ApiServiceProxies.LongGoalsServiceProxy,
        ApiServiceProxies.TreatmentDiagnosisesServiceProxy,
        ApiServiceProxies.TransitionPlansServiceProxy,
        ApiServiceProxies.DischargePlansServiceProxy,
        ApiServiceProxies.SupportServicesServiceProxy,
        ApiServiceProxies.DemoReferralMedicationsesServiceProxy,
        ApiServiceProxies.TreatmentModesServiceProxy,
        ApiServiceProxies.TreatmentPlansServiceProxy,
        ApiServiceProxies.DemoReferralsServiceProxy,
        ApiServiceProxies.ClientNotesServiceProxy,
        ApiServiceProxies.MedicationsServiceProxy,
        ApiServiceProxies.ClientAllergiesServiceProxy,
        ApiServiceProxies.VitalsServiceProxy,
        ApiServiceProxies.ClientOrientationListsServiceProxy,
        ApiServiceProxies.ProgramEnrollmentsServiceProxy,
        ApiServiceProxies.ClientSocialDiagnosisesServiceProxy,
        ApiServiceProxies.BehavioralDiagnosesesServiceProxy,
        ApiServiceProxies.ClientprovidersServiceProxy,
        ApiServiceProxies.ClientpoliciesServiceProxy,
        ApiServiceProxies.SerutilizationsServiceProxy,
        ApiServiceProxies.EefdetailsServiceProxy,
        ApiServiceProxies.ClientHealthhistoriesServiceProxy,
        ApiServiceProxies.HospitalizationsServiceProxy,
        ApiServiceProxies.ClientcontactsServiceProxy,
        ApiServiceProxies.MiscinfosServiceProxy,
        ApiServiceProxies.ClientsServiceProxy,
        ApiServiceProxies.AllergyMastersServiceProxy,
        ApiServiceProxies.DoseunitsServiceProxy,
        ApiServiceProxies.MedicationMastersServiceProxy,
        ApiServiceProxies.PlantypesServiceProxy,
        ApiServiceProxies.RelationshipsServiceProxy,
        ApiServiceProxies.ReferralPointsServiceProxy,
        ApiServiceProxies.ReferralCloseReasonsServiceProxy,
        ApiServiceProxies.DemosServiceProxy,
        ApiServiceProxies.HealthCareServicesServiceProxy,
        ApiServiceProxies.CountiesServiceProxy,
        ApiServiceProxies.UserLanguagesServiceProxy,
        ApiServiceProxies.DocumentsServiceProxy,
        ApiServiceProxies.ReferralNotesServiceProxy,
        ApiServiceProxies.ReferralAllergiesServiceProxy,
        ApiServiceProxies.ReferralMedicationsServiceProxy,
        ApiServiceProxies.ReferralPayersServiceProxy,
        ApiServiceProxies.PayersServiceProxy,
        ApiServiceProxies.ReferralSourcesServiceProxy,
        ApiServiceProxies.ReferralsServiceProxy,
        ApiServiceProxies.ReferralContactsServiceProxy,
        ApiServiceProxies.LocationsServiceProxy,
        ApiServiceProxies.OrganizationsServiceProxy,
        ApiServiceProxies.OrganizationTypesServiceProxy,
        ApiServiceProxies.AuditLogServiceProxy,
        ApiServiceProxies.CachingServiceProxy,
        ApiServiceProxies.ChatServiceProxy,
        ApiServiceProxies.CommonLookupServiceProxy,
        ApiServiceProxies.EditionServiceProxy,
        ApiServiceProxies.FriendshipServiceProxy,
        ApiServiceProxies.HostSettingsServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.LanguageServiceProxy,
        ApiServiceProxies.NotificationServiceProxy,
        ApiServiceProxies.OrganizationUnitServiceProxy,
        ApiServiceProxies.PermissionServiceProxy,
        ApiServiceProxies.ProfileServiceProxy,
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.TenantDashboardServiceProxy,
        ApiServiceProxies.TenantSettingsServiceProxy,
        ApiServiceProxies.TimingServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.UserLinkServiceProxy,
        ApiServiceProxies.UserLoginServiceProxy,
        ApiServiceProxies.WebLogServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.TenantRegistrationServiceProxy,
        ApiServiceProxies.HostDashboardServiceProxy,
        ApiServiceProxies.PaymentServiceProxy,
        ApiServiceProxies.DemoUiComponentsServiceProxy,
        ApiServiceProxies.InvoiceServiceProxy,
        ApiServiceProxies.SubscriptionServiceProxy,
        ApiServiceProxies.InstallServiceProxy,
        ApiServiceProxies.UiCustomizationSettingsServiceProxy,
        ApiServiceProxies.PayPalPaymentServiceProxy,
        ApiServiceProxies.StripePaymentServiceProxy,
        ApiServiceProxies.DashboardCustomizationServiceProxy,
        ApiServiceProxies.WebhookEventServiceProxy,
        ApiServiceProxies.WebhookSubscriptionServiceProxy,
        ApiServiceProxies.WebhookSendAttemptServiceProxy,
        ApiServiceProxies.UserDelegationServiceProxy,
        ApiServiceProxies.DynamicPropertyServiceProxy,
        ApiServiceProxies.DynamicEntityPropertyDefinitionServiceProxy,
        ApiServiceProxies.DynamicEntityPropertyServiceProxy,
        ApiServiceProxies.DynamicPropertyValueServiceProxy,
        ApiServiceProxies.DynamicEntityPropertyValueServiceProxy,
        ApiServiceProxies.TwitterServiceProxy,
        ApiServiceProxies.EntityChangeServiceProxy,
        ApiServiceProxies.CommonServiceProxy,
        ApiServiceProxies.LegalAgenciesServiceProxy,
        ApiServiceProxies.IntakeSocialDiagnosisesServiceProxy,
        ApiServiceProxies.ReferralInfosServiceProxy,
        ApiServiceProxies.IntakeMedicationsServiceProxy,
        ApiServiceProxies.PsychosocialAssessmentsServiceProxy,
        ApiServiceProxies.RiskServicesServiceProxy,
        ApiServiceProxies.PsychiatricSymptomsServiceProxy,
        ApiServiceProxies.IntakeAllergiesServiceProxy,
        ApiServiceProxies.SomaticIssuesServiceProxy,
        ApiServiceProxies.IntakeEefDetailsServiceProxy,
        ApiServiceProxies.IntakeclientcontactsServiceProxy,
        ApiServiceProxies.IntakeHospitalizationsServiceProxy,
        ApiServiceProxies.HousingsServiceProxy,
        ApiServiceProxies.MsesServiceProxy,
        ApiServiceProxies.CraftsServiceProxy,
        ApiServiceProxies.DastsServiceProxy,
        ApiServiceProxies.CagesServiceProxy,
        ApiServiceProxies.IntakeClientsServiceProxy,
        ApiServiceProxies.ClientPractitionersServiceProxy,
        ApiServiceProxies.SomaticDruglistsServiceProxy,
        ApiServiceProxies.PreviousTreatmentsServiceProxy,
        ApiServiceProxies.IntakeMedicationList_oldsServiceProxy,
        ApiServiceProxies.LegalchargesServiceProxy,
        ApiServiceProxies.IntakeDiagnosesesServiceProxy,
        ApiServiceProxies.PsychSkillDeficitsServiceProxy,
        ApiServiceProxies.FamilyProcreationsServiceProxy,
        ApiServiceProxies.FamilyOriginsServiceProxy,
        ApiServiceProxies.PsychViolentBehaviorsServiceProxy,
        ApiServiceProxies.PsychiatricSuicidalsServiceProxy,
        ApiServiceProxies.IntakeSymptomsServiceProxy,
        ApiServiceProxies.ReferralForIntakeServiceProxy,
        ApiServiceProxies.CommonComponentServiceProxy,
        ApiServiceProxies.ClientForIntakeEditServiceProxy,
        ApiServiceProxies.IntakeClientRecordsServiceProxy,
        ApiServiceProxies.ClientRecordsServiceProxy,
        ApiServiceProxies.DLAsReportServiceProxy,
        ApiServiceProxies.DischargeSummaryClientRecordsServiceProxy,
        ApiServiceProxies.PSPClientRecordsServiceProxy,
         ApiServiceProxies.MonthlyProgrssNotesServiceProxy,
         ApiServiceProxies.RehabProgrssNotesServiceProxy,
         ApiServiceProxies.RehabProgrssNoteRecordsServiceProxy,
         ApiServiceProxies.DocumenttypesServiceProxy,
         ApiServiceProxies.FrequenciesServiceProxy,
         ApiServiceProxies.SpecialitiesServiceProxy,
         ApiServiceProxies.CountriesServiceProxy,
         ApiServiceProxies.StatesServiceProxy,
         ApiServiceProxies.SeveritiesServiceProxy,
         ApiServiceProxies.GroupContactNotesServiceProxy,
         ApiServiceProxies.IndividualNotesServiceProxy,
         ApiServiceProxies.AttendenceStatusesServiceProxy,
         ApiServiceProxies.ICCN_BillsServiceProxy,
         ApiServiceProxies.ICCN_NotesServiceProxy,
         ApiServiceProxies.Individual_Masters_ValuesServiceProxy,
         ApiServiceProxies.IndividualClinicalNotesServiceProxy,
         ApiServiceProxies.ICCN_GoalsServiceProxy,
         ApiServiceProxies.SvcsInvoicesServiceProxy,
         ApiServiceProxies.ICCN_RISKsServiceProxy ,
         ApiServiceProxies.Status_Of_AssignmentsServiceProxy ,
         ApiServiceProxies.ICCN_MSEsServiceProxy,


         ApiServiceProxies.MedMedicationsServiceProxy,
         ApiServiceProxies.MedManagementRecordsServiceProxy,
         ApiServiceProxies.MedicalDecisionsServiceProxy,
         ApiServiceProxies.AttendenceStatusesServiceProxy,
         ApiServiceProxies.MedDiagnosisServiceProxy,
         ApiServiceProxies.MedManagementVitalsServiceProxy,
         ApiServiceProxies.RcopiaServiceProxy,
         ApiServiceProxies.HealthHomesServiceProxy,
         ApiServiceProxies.HealthHomeSummariesServiceProxy,
         ApiServiceProxies.HealthHomeSystemAreasServiceProxy,
         ApiServiceProxies.FamilyHealthHistoriesServiceProxy,
         ApiServiceProxies.HealthStatusesServiceProxy,
         ApiServiceProxies.HealthGoalsServiceProxy,
         ApiServiceProxies.RecommendationsServiceProxy ,
         ApiServiceProxies.FollowupNotesServiceProxy  ,
         ApiServiceProxies.PainAssessmentScreeningsServiceProxy  ,
         ApiServiceProxies.ImmunizationsServiceProxy  ,
         ApiServiceProxies.OutComeObjectsServiceProxy   ,
         ApiServiceProxies.SubstanceUsesServiceProxy   ,

        ApiServiceProxies.ServicePlanRecordsServiceProxy,
        ApiServiceProxies.RecentExaminationsServiceProxy ,
        ApiServiceProxies.HealthPsychiatricsServiceProxy  ,
        ApiServiceProxies.RehabNotesServiceProxy  ,
        ApiServiceProxies.RehabNoteRecordsServiceProxy  ,
        ApiServiceProxies.ClientChartDropOffServiceProxy  ,
        ApiServiceProxies.GroupContactNoteRecordsServiceProxy  ,
        ApiServiceProxies.IndividualClinicalNoteRecordsServiceProxy  ,

        { provide: RefreshTokenService, useClass: ZeroRefreshTokenService },
        { provide: AbpHttpConfigurationService, useClass: ZeroTemplateHttpConfigurationService },
        { provide: HTTP_INTERCEPTORS, useClass: ZeroTemplateHttpInterceptor, multi: true },
    ],
})
export class ServiceProxyModule {}
